import {
  GridAggregationFunction,
  GridColDef,
  GridRowId,
} from '@mui/x-data-grid-premium'
import { roundNumber } from './helperMethods'

interface GridAggregationParams<V = any> {
  values: (V | undefined)[]
  groupId: GridRowId
  field: GridColDef['field']
}

export const renderCellAggregation: GridAggregationFunction<
  number,
  number | null
> = {
  apply: (params: GridAggregationParams<number>) => {
    if (params.values.length === 0) {
      return null
    }
    return params.values.reduce((sum, value) => {
      sum = sum ?? 0
      value = value ?? 0
      return sum + value
    }, 0)
  },
  label: 'sum',
  valueFormatter: (value) => {
    return roundNumber(value)
  },
  columnTypes: ['number'],
}

export const renderCellNoAggregation: GridAggregationFunction<string> = {
  apply: (params: GridAggregationParams<unknown>) => {
    return '-'
  },
  label: '',
}
